module.exports = __webpack_public_path__ + "img/prop-shopping-2-right.84bbcb2c.png";